import { createFormHooks } from 'app-components/utils/createForm/formHooks';
import { transactionRulesFormFactory } from './transactionRulesForm';

export const { FormProvider, useField, useMultiFields, useIsDirty, useIsFormValid, useSelector, useManager } =
  createFormHooks(transactionRulesFormFactory, {} as { additionalSubmitArg: boolean });
